import React from 'react';
import LeftRight from "../../components/ui/LeftRight";
import s1 from "../../assets/images/products/pages/file-cloud/1.png";
import {cardData} from "../../constants/products/fileCloud";
import {fileSharingMeta} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import {useTranslation} from "react-i18next";

const FileCloud = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={fileSharingMeta.title}
        description={fileSharingMeta.description}
        canonical={fileSharingMeta.canonical}
        keywords={fileSharingMeta.keywords}
        ogTitle={fileSharingMeta.title}
        ogDescription={fileSharingMeta.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto mt-12" >
        <h2 className={`text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
          {t('fileCloudPage.fileCloudTitle')}
        </h2>
        <div className="w-full md:w-[70%] mx-auto bg-red-300">
          <img
            className="w-full"
            src={s1||'img-alt'}
            alt="file cloud"
          />
        </div>
        <div className="mt-12">
          <LeftRight
            sectionClass={`pb-10`}
            title={t('fileCloudPage.remoteAccess')}
            subtitle={t('fileCloudPage.workFlowSoftware')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            imgClass={'w-[50%] mx-auto'}
            descriptionList={[
              t('fileCloudPage.remoteAccessDescription'),
            ]}
            icon={false}
            image={require(`../../assets/images/products/pages/file-cloud/2.png`)}
          />
        </div>
      </div>
      <div className="add-square-bg">
        <div className="md:w-theme-container w-mobile-container mx-auto py-20">
          {cardData.map((item) => (
            <LeftRight
              key={item.id}
              title={t(`fileCloudPage.${item.title}`)}
              subtitle={t(`fileCloudPage.${item.subtitle}`)}
              titleClass={item.titleClass}
              {...(item.textWidthClass && { textWidthClass: item.textWidthClass })}
              isLeft={item.isLeft}
              textPosition={item.textPosition}
              descriptionPosition={item.descriptionPosition}
              imgClass={item.imgClass}
              descriptionList={item.descriptionList}
              descriptionListPrefix={'fileCloudPage'}
              icon={item.icon}
              image={require(`../../assets/images/${item.image}`)}
              downloadBtn={item.id===1&&true}
              downloadLink={require("../../assets/uploads/pdf/file-cloud.pdf")}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FileCloud;
